<template>
  <div class="game-list-tab">
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="page"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-listeners="tableListeners"
    >
      <template #search-tags="{ query }">
        <TypeSelect style="width: 100%" v-model="query.tags" type="gameTag" placeholder="选择游戏标签" clearable />
      </template>

      <template #table-header>
        <div>
          <el-button type="primary" size="mini" @click="handleBatchUpdateStatus(1)">批量开启</el-button>
          <el-button type="danger" size="mini" @click="handleBatchUpdateStatus(2)">批量关闭</el-button>
        </div>
      </template>

      <template #colTags="{ row }">
        <div class="tags-cell-wrap">
          <div class="tags-cell-text" :class="{ 'is-clamped': needExpandTags(row.tags) }">
            {{ formatTagsDisplay(row.tags) }}
          </div>
        </div>
      </template>
      <template #colStatus="{ row }">
        <el-switch
          size="mini"
          v-model="row.status"
          :active-value="1"
          :inactive-value="2"
          @change="handleStatusChange([row.game_id], row.status)"
        />
      </template>
      <template #colGameIcon="{ row }">
        <el-image
          v-if="row.game_icon"
          :src="row.game_icon"
          fit="cover"
          :preview-src-list="[row.game_icon]"
          style="width: 36px; height: 36px; border-radius: 4px"
        />
        <span v-else>无图片</span>
      </template>
      <template #colCreatedAt="{ row }">{{ parseTime(row.created_at) }}</template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handleEditGame(row)">编辑</el-button>
      </template>
    </SchemaTablePage>

    <ManageGameDialog
      :is-visible="gameDialogVisible"
      :game-data="currentGame"
      @save-success="handleGameSaveSuccess"
      @close="gameDialogVisible = false"
    />

    <ManageGameImportDialog
      :is-visible="importDialogVisible"
      @import-success="handleImportSuccess"
      @close="importDialogVisible = false"
    />
  </div>
</template>

<script>
import { changeStatus, listGameItems } from '@/api/gameManage/gameList.js'
import TypeSelect from '@/pages/common/select/index.vue'
import { parseTime } from '@/utils'
import ManageGameDialog from './ManageGameDialog.vue'
import ManageGameImportDialog from './ManageGameImportDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

const GAME_TYPE_OPTIONS = [
  { label: '全部', value: '' },
  { label: 'SLOT', value: 'SLOT' },
  { label: 'TABLE', value: 'TABLE' },
  { label: 'LIVE', value: 'LIVE' },
  { label: 'FISH', value: 'FISH' },
  { label: 'ETC', value: 'ETC' },
]

export default {
  name: 'ManageGameListTab',
  components: {
    ManageGameDialog,
    ManageGameImportDialog,
    SchemaTablePage,
    TypeSelect,
  },
  data() {
    return {
      defaultQuery: {
        game_provider: '',
        game_id: '',
        game_type: '',
        status: '',
        tags: '',
        game_name: '',
      },
      searchSchema: [
        {
          prop: 'game_name',
          label: '游戏名称',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'game_provider',
          label: '游戏厂商',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'game_id',
          label: '游戏编号',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'game_type',
          label: '游戏类型',
          component: 'select',
          componentProps: { clearable: true },
          options: GAME_TYPE_OPTIONS,
        },
        {
          prop: 'tags',
          label: '游戏标签',
          component: 'slot',
          slot: 'search-tags',
        },
        {
          prop: 'status',
          label: '状态',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: '' },
            { label: '启用', value: 1 },
            { label: '禁用', value: 2 },
          ],
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { type: 'selection', width: 40, align: 'center', resizable: false },
        { prop: 'game_name', label: '游戏名称', minWidth: 160, resizable: false },
        { prop: 'game_id', label: '游戏编号', minWidth: 100, resizable: false },
        { prop: 'sort', label: '排序', width: 80, resizable: false },
        { prop: 'game_provider', label: '游戏厂商', minWidth: 80, resizable: false },
        { prop: 'game_type', label: '游戏类型', width: 80, resizable: false },
        { prop: 'tags', label: '游戏标签', width: 150, resizable: false, slot: 'colTags' },
        { prop: 'status', label: '状态', width: 80, align: 'center', resizable: false, slot: 'colStatus' },
        { prop: 'game_icon', label: '游戏图片', width: 80, align: 'center', resizable: false, slot: 'colGameIcon' },
        { prop: 'created_at', label: '创建时间', width: 140, resizable: false, slot: 'colCreatedAt' },
        {
          fixed: 'right',
          prop: 'action',
          label: '操作',
          width: 80,
          align: 'center',
          resizable: false,
          slot: 'colActions',
        },
      ],
      selectedGames: [],
      gameDialogVisible: false,
      importDialogVisible: false,
      currentGame: null,
    }
  },
  computed: {
    tableListeners() {
      return {
        'selection-change': this.handleSelectionChange,
      }
    },
  },
  methods: {
    parseTime,
    request(params) {
      return listGameItems(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
        game_name: query.game_name,
        game_provider: query.game_provider,
        game_id: query.game_id,
        game_type: query.game_type,
        status: query.status,
        tags: query.tags ? [query.tags] : [],
      }
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key]
      })
      return params
    },
    parseResult(response) {
      if (!response || response.code !== 0) {
        if (response && response.code !== 0) {
          this.$message.error('加载游戏列表失败：' + (response.msg || '未知错误'))
        }
        return { list: [], total: 0 }
      }
      return {
        list: response.data.list || [],
        total: response.data.total != null ? response.data.total : 0,
      }
    },
    reloadTable() {
      this.$refs.tablePageRef?.reload?.()
    },
    formatTagsDisplay(tags) {
      if (!tags) return '-'
      let arr = []
      if (Array.isArray(tags)) {
        arr = tags.map(t => (typeof t === 'object' && t != null && t.title ? t.title : String(t)))
      } else {
        arr = String(tags)
          .split(/[,，、]/)
          .map(s => s.trim())
          .filter(Boolean)
      }
      return arr.length ? arr.join('、') : '-'
    },
    needExpandTags(tags) {
      const text = this.formatTagsDisplay(tags)
      return text !== '-' && text.length > 12
    },
    handleSelectionChange(selection) {
      this.selectedGames = selection
    },
    handleEditGame(game) {
      this.currentGame = { ...game }
      this.gameDialogVisible = true
    },
    handleGameSaveSuccess() {
      this.gameDialogVisible = false
      this.reloadTable()
    },
    handleImportSuccess() {
      this.importDialogVisible = false
      this.reloadTable()
    },
    async handleStatusChange(game_id_list, status) {
      try {
        const response = await changeStatus({ game_id: game_id_list, status })
        if (response.code === 0) {
          this.$message.success('状态变更成功')
          this.reloadTable()
        } else {
          this.$message.error('状态变更失败：' + (response.msg || '未知错误'))
          this.reloadTable()
        }
      } catch (error) {
        this.$message.error('状态变更失败：' + error.message)
        this.reloadTable()
      }
    },
    async handleBatchUpdateStatus(status) {
      const game_id_list = this.selectedGames.map(item => item.game_id)
      if (game_id_list.length === 0) {
        this.$message.info('请选择要变更状态的游戏')
        return
      }
      await this.handleStatusChange(game_id_list, status)
    },
  },
}
</script>

<style scoped>
.tags-cell-wrap {
  max-width: 150px;
}

.tags-cell-text {
  word-break: break-word;
  word-wrap: break-word;
  line-height: 1.4;
  font-size: 12px;
}

.tags-cell-text.is-clamped {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
